<script>
export default {
  props:{
    setting: {
      default: () => {
        return {
          // 低功耗
          lowPowerConsumption: false,
          // sim卡 1单卡 2双卡
          sim: 2,
          // sim1卡信号
          sim1Signal: 4,
          // sim2卡信号
          sim2Signal: 4,
          // 电量
          electricity: 56,
          // 显示时间
          time: new Date().getTime(),
          // wifi
          wifi: true,
          // wifi信号
          wifiSignal: 2
        }
      }
    },
    // 主题 分别是顶部信号电源主题  底部切换线的主题 white | black
    theme: {
      default: () => {
        return {
          topTheme: 'black',
          bottomTheme: 'black'
        }
      }
    }
  },
  computed:{
    settingData(){
      return this.setting
    },
    themeData(){
      return this.theme
    }
  }
}
</script>

<template>
  <div class="phoneIos">
    <!--浅色模式    -->
    <div
      class="phoneIos-top flex-between"
      v-if="themeData.topTheme === 'white'"
    >
      <div class="phoneIos-top-time">{{ settingData.time | filterTime2('HH:mm') }}</div>
      <div class="phoneIos-top-right flex-end">
        <div class="phoneIos-top-right-sim flex-center">
          <div
            class="phoneIos-top-right-sim-item1 flex-center"
            v-if="settingData.sim === 1"
          >
            <img
              v-if="settingData.sim1Signal === 0"
              src="@/assets/img/ios/bs1.png"
              alt=""
            />
            <img
              v-else-if="settingData.sim1Signal === 1"
              src="@/assets/img/ios/bs2.png"
              alt=""
            />
            <img
              v-else-if="settingData.sim1Signal === 2"
              src="@/assets/img/ios/bs3.png"
              alt=""
            />
            <img
              v-else-if="settingData.sim1Signal === 3"
              src="@/assets/img/ios/bs4.png"
              alt=""
            />
            <img
              v-else
              src="@/assets/img/ios/bs5.png"
              alt=""
            />
          </div>
          <div
            class="phoneIos-top-right-sim-item2 flex-center"
            v-else
          >
            <img
              class="img1"
              v-if="settingData.sim1Signal === 0"
              src="@/assets/img/ios/bs1.png"
              alt=""
            />
            <img
              class="img1"
              v-else-if="settingData.sim1Signal === 1"
              src="@/assets/img/ios/bs2.png"
              alt=""
            />
            <img
              class="img1"
              v-else-if="settingData.sim1Signal === 2"
              src="@/assets/img/ios/bs3.png"
              alt=""
            />
            <img
              class="img1"
              v-else-if="settingData.sim1Signal === 3"
              src="@/assets/img/ios/bs4.png"
              alt=""
            />
            <img
              class="img1"
              v-else
              src="@/assets/img/ios/bs5.png"
              alt=""
            />

            <img
              class="img2"
              v-if="settingData.sim2Signal === 0"
              src="@/assets/img/ios/bs11.png"
              alt=""
            />
            <img
              class="img2"
              v-else-if="settingData.sim2Signal === 1"
              src="@/assets/img/ios/bs22.png"
              alt=""
            />
            <img
              class="img2"
              v-else-if="settingData.sim2Signal === 2"
              src="@/assets/img/ios/bs33.png"
              alt=""
            />
            <img
              class="img2"
              v-else-if="settingData.sim2Signal === 3"
              src="@/assets/img/ios/bs44.png"
              alt=""
            />
            <img
              class="img2"
              v-else
              src="@/assets/img/ios/bs55.png"
              alt=""
            />
          </div>
        </div>

        <!--  wifi/4g        -->
        <div class="phoneIos-top-right-wifi">
          <div
            class="phoneIos-top-right-wifi-img flex-center"
            v-if="settingData.wifi"
          >
            <img
              v-if="settingData.wifiSignal === 1"
              src="@/assets/img/ios/ios-wifi-1-bs.png"
              alt=""
            />
            <img
              v-else-if="settingData.wifiSignal === 2"
              src="@/assets/img/ios/ios-wifi-2-bs.png"
              alt=""
            />
            <img
              v-else
              src="@/assets/img/ios/ios-wifi-3-bs.png"
              alt=""
            />
          </div>
          <div
            v-else
            class="phoneIos-top-right-4g-img flex-center"
          >
            <img
              src="@/assets/img/ios/bslte.png"
              alt=""
            />
          </div>
        </div>

        <div class="phoneIos-top-right-electricity">
          <!-- 电量         -->
          <img
            class="phoneIos-top-right-electricity-bg"
            src="@/assets/img/ios/ios-battery-bs.png"
            alt=""
          >
          <div
            class="electricity-cont"
            v-if="settingData.lowPowerConsumption"
            :style="{
              width: `${settingData.electricity}%`,
              'background-color': 'rgba(237,204,108,1)'
            }"
          ></div>
          <div
            class="electricity-cont"
            v-else
            :style="{
              width: `${settingData.electricity}%`,
              'background-color': settingData.electricity > 20 ? 'white' : 'red'
            }"
          ></div>
        </div>
      </div>
    </div>

    <!-- 深色模式   -->

    <div
      class="phoneIos-top phoneIos-top-dark flex-between"
      v-else
    >
      <div class="phoneIos-top-time">{{ settingData.time | filterTime2('HH:mm') }}</div>
      <div class="phoneIos-top-right flex-end">
        <div class="phoneIos-top-right-sim flex-center">
          <div
            class="phoneIos-top-right-sim-item1 flex-center"
            v-if="settingData.sim === 1"
          >
            <img
              v-if="settingData.sim1Signal === 0"
              src="@/assets/img/ios/hs1.png"
              alt=""
            />
            <img
              v-else-if="settingData.sim1Signal === 1"
              src="@/assets/img/ios/hs2.png"
              alt=""
            />
            <img
              v-else-if="settingData.sim1Signal === 2"
              src="@/assets/img/ios/hs3.png"
              alt=""
            />
            <img
              v-else-if="settingData.sim1Signal === 3"
              src="@/assets/img/ios/hs4.png"
              alt=""
            />
            <img
              v-else
              src="@/assets/img/ios/hs5.png"
              alt=""
            />
          </div>
          <div
            class="phoneIos-top-right-sim-item2 flex-center"
            v-else
          >
            <img
              class="img1"
              v-if="settingData.sim1Signal === 0"
              src="@/assets/img/ios/hs1.png"
              alt=""
            />
            <img
              class="img1"
              v-else-if="settingData.sim1Signal === 1"
              src="@/assets/img/ios/hs2.png"
              alt=""
            />
            <img
              class="img1"
              v-else-if="settingData.sim1Signal === 2"
              src="@/assets/img/ios/hs3.png"
              alt=""
            />
            <img
              class="img1"
              v-else-if="settingData.sim1Signal === 3"
              src="@/assets/img/ios/hs4.png"
              alt=""
            />
            <img
              class="img1"
              v-else
              src="@/assets/img/ios/hs5.png"
              alt=""
            />

            <img
              class="img2"
              v-if="settingData.sim2Signal === 0"
              src="@/assets/img/ios/hs11.png"
              alt=""
            />
            <img
              class="img2"
              v-else-if="settingData.sim2Signal === 1"
              src="@/assets/img/ios/hs22.png"
              alt=""
            />
            <img
              class="img2"
              v-else-if="settingData.sim2Signal === 2"
              src="@/assets/img/ios/hs33.png"
              alt=""
            />
            <img
              class="img2"
              v-else-if="settingData.sim2Signal === 3"
              src="@/assets/img/ios/hs44.png"
              alt=""
            />
            <img
              class="img2"
              v-else
              src="@/assets/img/ios/hs55.png"
              alt=""
            />
          </div>
        </div>

        <!--  wifi/4g        -->
        <div class="phoneIos-top-right-wifi">
          <div
            class="phoneIos-top-right-wifi-img flex-center"
            v-if="settingData.wifi"
          >
            <img
              v-if="settingData.wifiSignal === 1"
              src="@/assets/img/ios/ios-wifi-1-dark.png"
              alt=""
            />
            <img
              v-else-if="settingData.wifiSignal === 2"
              src="@/assets/img/ios/ios-wifi-2-dark.png"
              alt=""
            />
            <img
              v-else
              src="@/assets/img/ios/ios-wifi-3-dark.png"
              alt=""
            />
          </div>
          <div
            v-else
            class="phoneIos-top-right-4g-img flex-center"
          >
            <img
              src="@/assets/img/ios/lte.png"
              alt=""
            />
          </div>
        </div>

        <div class="phoneIos-top-right-electricity phoneIos-top-right-electricity-dark">
          <img
            class="phoneIos-top-right-electricity-bg"
            src="@/assets/img/ios/ios-battery-dark.png"
            alt=""
          >
          <!-- 电量         -->
          <div
            class="electricity-cont"
            v-if="settingData.lowPowerConsumption"
            :style="{
              width: `${settingData.electricity}%`,
              'background-color': 'rgba(237,204,108,1)'
            }"
          ></div>
          <div
            class="electricity-cont"
            v-else
            :style="{
              width: `${settingData.electricity}%`,
              'background-color': settingData.electricity > 20 ? '#000000' : 'red'
            }"
          ></div>
        </div>
      </div>
    </div>

    <div
      class="phoneIos-line"
      v-if="themeData.bottomTheme === 'white'"
    ></div>
    <div
      class="phoneIos-line"
      style="background-color: black"
      v-else
    ></div>

    <slot></slot>
  </div>
</template>

<style scoped lang="less">
.phoneIos {
  width: 375px;
  height: 812px;
  position: relative;

  ::-webkit-scrollbar {
    display: none;
  }
  .phoneIos-top {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 11px 14px 0 30px;
    box-sizing: border-box;
    color: white;
    z-index: 99;

    .phoneIos-top-time {
      font-size: 15.3px;
      font-family: 'systemmedium';
    }

    .phoneIos-top-right {
      .phoneIos-top-right-sim-item1 {
        width: 18px;
        height: 11px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .phoneIos-top-right-sim-item2 {
        flex-direction: column;

        .img1 {
          width: 14px;
        }
        .img2 {
          margin-top: 2px;
          width: 14px;
        }
      }

      .phoneIos-top-right-wifi {
        margin: 0 5px;

        .phoneIos-top-right-wifi-img {
          width: 21px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .phoneIos-top-right-4g-img {
          width: 21px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .phoneIos-top-right-electricity {
        width: 22px;
        height: 12px;
        padding: 2.4px 4px 2.4px 1.8px;
        box-sizing: border-box;
        position: relative;

        .electricity-cont {
          height: 100%;
          border-radius: 1px;
          width: 100%;
          position: relative;
          z-index: 20;
        }
        &-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 10;
          left: 0;
          top: 0;
        }
      }

      .phoneIos-top-right-electricity-dark {
        width: 22px;
        height: 12px;
        padding: 2.4px 4px 2.4px 1.8px;
        box-sizing: border-box;
      }
    }
  }

  .phoneIos-top-dark {
    color: #000000;
  }

  .phoneIos-line {
    width: 139px;
    position: absolute;
    left: 118px;
    bottom: 7px;
    background-color: white;
    height: 5px;
    border-radius: 5px;
    z-index: 99;
  }
}
</style>
